import { nextReconnectDelay } from '../../lib/live/backoff';

export const SAVE_RETRY_MESSAGE = 'Not saved, reconnecting…';

/** The save did not reach the server (offline, timeout, 5xx); the edit is still only in the editor. */
export function isRetryableSaveError(err: unknown): boolean {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return true;
  }
  if (err instanceof TypeError) {
    return true;
  }
  if (!(err instanceof Error)) {
    return false;
  }
  return /^Request timed out\b/.test(err.message) || /^Request failed \(5\d\d\)$/.test(err.message);
}

export function saveRetryDelay(attempt: number): number {
  return nextReconnectDelay(attempt);
}
